<template>
  <div>
    <v-dialog
      v-model="dialog"
      width="450">
      <v-card class="pa-4" v-if="Object.keys(detail).length > 0">
        <v-card-title class="body-2 pb-5">
          {{ detail.logNotification.title }}
        </v-card-title>
        <v-card-subtitle class="caption pb-3">
          {{ detail.logDatetime | datetime }}
        </v-card-subtitle>
        <v-card-text class="body-2 font-weight-light pb-3" v-html="convert(detail.logNotification.body)">
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            rounded
            small
            width="70"
            color="#F5F5F5"
            elevation="0"
            light
            class="text-capitalize"
            @click="dialog = false">
            Tutup
          </v-btn>
          <v-btn
            rounded
            small
            width="120"
            color="#3a3a3a"
            elevation="0"
            class="white--text text-capitalize"
            @click="dialog = false"
            :to="`/transaction/selling/${detail.logInvoiceId}`">
            Lihat Detail
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-app-bar
      fixed
      app
      light
      color="white"
      elevation="0">
      <v-app-bar-nav-icon
        v-if="$vuetify.breakpoint.name === 'xs' || $vuetify.breakpoint.name === 'sm' || $vuetify.breakpoint.name === 'md'"
        @click.stop="drawer = !drawer"/>
      <v-toolbar-title :class="$vuetify.breakpoint.name === 'xs' ? '' : 'ml-3 mt-5'">
        <img width="120" :src="require('../assets/logo/logocendekia2.png')">
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu
        :class="!miniVariant ? 'mr-5' : $vuetify.breakpoint.name === 'xs' ? 'mr-1' : 'mr-5'"
        close-on-content-click nudge-width="250" offset-x
        v-if="token">
        <template v-slot:activator="{ on }">
          <div v-on="on">
            <v-btn icon
              @click="fetchNotification()">
              <v-badge
                v-if="count > 0"
                color="red"
                overlap>
                <span slot="badge" v-if="count >= 10">
                  9+
                </span>
                <span slot="badge" v-else>
                  {{ count }}
                </span>
                <span slot="default">
                  <v-icon color="#269B91">mdi-bell</v-icon>
                </span>
              </v-badge>
              <span slot="default"
                v-if="count < 1">
                <v-icon color="#269B91">mdi-bell</v-icon>
              </span>
            </v-btn>
          </div>
        </template>
        <v-card>
          <v-list rounded class="overflow-y-auto" max-height="400" max-width="300">
            <v-skeleton-loader
              class="ma-auto"
              :loading="process.run"
              transition="scale-transition"
              :tile="false"
              type="list-item-two-line"
              v-for="(item, index) in process.run ? 10:notification" 
              :key="index">
              <v-list-item-group>
                <v-list-item
                  v-if="!process.run && notification.length > 0"
                  @click="toRead(item)">
                  <v-list-item-avatar>
                    <v-icon :color="item.logStatusOpen === 'yes' ? 'grey' : '#269b91'">mdi-bell</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title class="body-2">
                      {{ item.logNotification.title }}
                    </v-list-item-title>
                    <v-list-item-subtitle class="caption mt-1">
                      {{ item.logDatetime | datetime }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-skeleton-loader>
            <v-list-item
              v-if="!process.run && notification.length < 1">
              <v-list-item-content>
                <v-list-item-title class="caption grey--text text-center justify-center">
                  Belum ada Pemberitahuan
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-divider class="ma-3 mt-0 mb-0"/>
          <v-card-actions>
            <v-btn
              block
              rounded
              color="#ff618a"
              class="text-capitalize caption"
              text
              to="/notification">
              Lihat Semua</v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
    </v-app-bar>
    <v-navigation-drawer
      v-model="drawer"
      :mini-variant.sync="miniVariant"
      fixed
      app
      dark
      color="#fa2f64"
      class="ma-3"
      style="max-height: calc(100% - 25px); z-index: 9999; border-radius: 15px;"
      v-if="$route.name !== 'login'">
      <v-list-item class="px-2">
        <router-link to="/profil">
          <v-list-item-avatar>
            <v-img :src="user.userUrlImg"></v-img>
          </v-list-item-avatar>
        </router-link>
        <router-link to="/profil" style="color:white; text-decoration:none;">
          <v-list-item-title>{{ user.userFullname }}</v-list-item-title>
        </router-link>
        <v-spacer></v-spacer>
        <v-btn
          icon
          @click.stop="miniVariant = !miniVariant">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
      </v-list-item>
      <v-list
        dense
        nav
        class="py-0">
        <v-list-item
          link
          to="/dashboard"
          :value="$route.name.split(' ')[0] === 'dashboard' ? true : false">
          <v-list-item-icon class="mr-3">
            <v-icon>mdi-apps</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Dashboard</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-list
        dense
        nav
        v-for="item in user.userPrivilege"
        :key="item.menuTitle"
        class="py-0">
        <v-list-item
          link
          v-if="item.submenuDetail.length < 1"
          :to="item.menuUrl"
          :value="$route.name.split(' ')[0] === item.menuUrl ? true : false">
          <v-list-item-icon class="mr-3">
            <v-icon>{{ item.menuIcon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item.menuTitle }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-group
          no-action
          v-if="item.submenuDetail.length > 0"
          color="#fff"
          :value="$route.name.split(' ')[0] === item.menuUrl ? true : false">
          <template v-slot:activator>
            <v-list-item-icon class="mr-3">
              <v-icon>{{ item.menuIcon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>
              {{ item.menuTitle }}
            </v-list-item-title>
          </template>
          <v-list-item
            v-for="(g, index) in item.submenuDetail"
            :key="index"
            :to="g.submenuUrl"
            link
            class="pl-7">
            <v-list-item-icon class="mr-3">
              <v-icon>{{ g.submenuIcon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>
              {{ g.submenuTitle }}
            </v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list>
       <template v-slot:append>
        <v-list
          class="pl-0">
          <v-list-item
            router
            exact
            @click="logout">
            <v-list-item-action class="mr-3">
              <v-icon color="white">mdi-logout</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="white--text">
                Keluar
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </template>
    </v-navigation-drawer>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "../service/Axios";
  import { TokenService } from "../service/Storage.Service";
  export default {
    data () {
      return {
        dialog: false,
        drawer: true,
        miniVariant: true,
        menu: [
          {
            text: 'Dashboard',
            icon: 'mdi-apps',
            to: '',
            hasParent: 0,
          },
          {
            text:'Admin',
            icon:'mdi-account',
            to:'admin',
            hasParent:0,
          },
          {
            text: 'Member',
            icon: 'mdi-account-multiple',
            to: 'member',
            hasParent: 0,
          },
          {
            text: 'Kelas',
            icon: 'mdi-library',
            to: 'class',
            hasParent: 0
          },
          {
            text: 'Materi',
            icon: 'mdi-library-shelves',
            to: 'library',
            hasParent: 0
          },
          {
            text: 'Penjualan',
            icon: 'mdi-wallet',
            to: 'transaction/selling',
            hasParent: 0
          },
          {
            text: 'Hak Akses',
            icon: 'mdi-access-point',
            to: 'access',
            hasParent: 1,
            submenu: [
              {
                text: 'Menu',
                icon: 'mdi-cogs',
                to: '/access/menu'
              },
              {
                text: 'Sub Menu',
                icon: 'mdi-cogs',
                to: '/access/sub-menu'
              },
            ]
          },
          {
            text: 'Web Config',
            icon: 'mdi-cogs',
            to: '',
            hasParent: 1,
            submenu: [
              {
                text: 'Konten',
                icon: 'mdi-cogs',
                to: '/config/content'
              },
              {
                text: 'Akun Bank Penerima',
                icon: 'mdi-cogs',
                to: '/config/bank/destination'
              },
              {
                text: 'Akun Bank Pengirim',
                icon: 'mdi-cogs',
                to: '/config/bank/recipient'
              },
              {
                text: 'Mentor',
                icon: 'mdi-cogs',
                to: '/config/mentor'
              },
              {
                text: 'Privasi',
                icon: 'mdi-cogs',
                to: '/config/privacy'
              },
              {
                text: 'Bantuan',
                icon: 'mdi-cogs',
                to: '/config/help'
              },
              {
                text: 'Tentang Kami',
                icon: 'mdi-cogs',
                to: '/config/aboutus'
              },
              {
                text: 'Sosial Media',
                icon: 'mdi-cogs',
                to: '/config/sosmed'
              },
              {
                text: 'Kategori',
                icon: 'mdi-cogs',
                to: '/config/category'
              },
              {
                text: 'Mitra',
                icon: 'mdi-cogs',
                to: '/config/partner'
              },
              {
                text: 'Pertanyaan',
                icon: 'mdi-cogs',
                to: '/config/question'
              },
            ]
          },
          {
            text: 'Telegram',
            icon: 'mdi-telegram',
            to: 'telegram',
            hasParent: 0,
          },
          {
            text: 'Landing Page',
            icon: 'mdi-web',
            to: 'landing',
            hasParent: 0,
          }
        ],
        pageAccess: false,
        notification: [],
        count: 0,
        detail: {},
        process: {
          run: false
        }
      }
    },
    watch: {
      '$route' (to, from) { 
        this.fetchCountNotification()
      }
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      token () {
        return this.$store.state.token
      }
    },
    mounted () {
      if (this.token) {
        this.access()
        this.fetchCountNotification()
      }
    },
    methods: {
      access() {
        for(let i in this.user.userPrivilege){
          if (this.user.userPrivilege[i].menuUrl.split('/')[1] === this.$route.path.split('/')[1]) {
            this.pageAccess = true
          } 
          if (this.pageAccess === false) {
            for(let j in this.user.userPrivilege[i].submenuDetail){
              if (this.user.userPrivilege[i].submenuDetail[j].submenuUrl.split('/')[1] !== this.$route.path.split('/')[1]) {
                this.pageAccess = false
              } else {
                this.pageAccess = true
              }
            }
          }
        }
        if (this.pageAccess === false) {
          if (this.$route.path !== '/dashboard') {
            window.location = '/dashboard'
          }
        }
      },
      async fetchNotification() {
        if (this.token) {
          this.process.run = true
          await get(`api/internal/notif`)
          .then((response) => {
            let res = response.data
            if (res.code === 200) {
              this.notification = res.data
              this.process.run = false
            }
          })
        }
      },
      async fetchCountNotification() {
        if (this.token) {
          await get(`api/internal/notif/count`)
          .then((response) => {
            let res = response.data
            if (res.code === 200) {
              this.count = res.data
            }
          })
        }
      },
      convert(item) {
        return item.replace(/&lt;/g, '<')
      },
      toRead(value) {
        this.detail = value
        put(`api/internal/notif/update/status/${this.detail.id}`, {
          data: {
            status: "yes"
          }
        })
        .then((response) => {
          if (response.data.code === 201) {
            this.fetchCountNotification()
            this.dialog = true
          }
        })
      },
      isMobile() {
        if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
          return true
        } else {
          return false
        }
      },
      logout() {
        TokenService.removeToken()
        window.location = '/login'
      }
    },
    created () {
      if (process.browser) {
        if ('Notification' in window && 'serviceWorker' in navigator) {
          navigator.serviceWorker.addEventListener('message', event => {
            this.fetchCountNotification() // fetch data real time
          })
        }
      }
    }
  }
</script>